import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { snakeCaseToTitleCase } from '~/lib/cases';
import { useDocumentsView } from '../../provider';
const ClauseElement = ({ clauseKey }) => {
    const { anchorDoc, comparatorDoc, selectedElement, setSelectedElement, anchorBookmark, setAnchorBookmark, comparatorBookmark, setComparatorBookmark, } = useDocumentsView();
    const [anchorClauses, setAnchorClauses] = useState([]);
    const [compClauses, setCompClauses] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedAnchorIndex, setSelectedAnchorIndex] = useState(0);
    const [selectedComparatorIndex, setSelectedComparatorIndex] = useState(0);
    const isSelected = selectedElement.length === 2 &&
        selectedElement[0] === 'clause' && selectedElement[1] === clauseKey;
    useEffect(() => {
        if (!anchorDoc || !comparatorDoc)
            return;
        setAnchorClauses(anchorDoc.data.clauses[clauseKey].sources || []);
        setCompClauses(comparatorDoc.data.clauses[clauseKey].sources || []);
    }, [clauseKey, anchorDoc, comparatorDoc]);
    useEffect(() => {
        if (isSelected) {
            const anchorSource = anchorClauses[selectedAnchorIndex];
            if (anchorSource && anchorSource.pageNumber && anchorSource.coordinates) {
                setAnchorBookmark([{ annotations: [{
                                pageNum: Number(anchorSource.pageNumber),
                                coordinates: anchorSource.coordinates,
                                confidenceScore: anchorSource.confidenceScore,
                            }] }]);
            }
            else {
                setAnchorBookmark([]);
            }
            const compSource = compClauses[selectedComparatorIndex];
            if (compSource && compSource.pageNumber && compSource.coordinates) {
                setComparatorBookmark([{ annotations: [{
                                pageNum: Number(compSource.pageNumber),
                                coordinates: compSource.coordinates,
                                confidenceScore: compSource.confidenceScore,
                            }] }]);
            }
            else {
                setComparatorBookmark([]);
            }
        }
        else if (selectedElement[1] === `clear-${clauseKey}` && (anchorBookmark.length || comparatorBookmark.length)) {
            setAnchorBookmark([]);
            setComparatorBookmark([]);
        }
    }, [isSelected, selectedAnchorIndex, selectedComparatorIndex]);
    const buildBody = () => {
        const elementOptionsClass = classnames('element-nav-options', {
            expanded: isExpanded,
        });
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'element-name-row' },
                React.createElement("div", { className: 'overflow-ellipsis' }, snakeCaseToTitleCase(clauseKey).replaceAll('100 Pct ', '')),
                React.createElement("span", { className: 'icons' },
                    compClauses && compClauses.some(c => c.coordinates && c.pageNumber) &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fas fa-file' })),
                    anchorClauses && anchorClauses.some(c => c.coordinates && c.pageNumber) &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fas fa-star' })))),
            React.createElement("div", { className: elementOptionsClass }, isExpanded && React.createElement(React.Fragment, null,
                !!(anchorClauses.length) && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'icon-anchor' },
                        React.createElement("i", { className: 'fas fa-star' })),
                    React.createElement("div", { className: 'document-options' }, (anchorClauses || []).map((clause, index) => {
                        const isOptionSelected = index === selectedAnchorIndex;
                        const optionContainerClass = classnames('option-container', {
                            selected: isSelected && isOptionSelected,
                        });
                        return React.createElement("div", { className: optionContainerClass, onClick: e => {
                                setSelectedAnchorIndex(index);
                                if (!isSelected)
                                    setSelectedElement(['clause', clauseKey]);
                                e.stopPropagation();
                            } },
                            "Page ",
                            clause.pageNumber);
                    }))),
                !!(compClauses.length) && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'icon-compare' },
                        React.createElement("i", { className: 'fas fa-file' })),
                    React.createElement("div", { className: 'document-options' }, (compClauses || []).map((clause, index) => {
                        const isOptionSelected = index === selectedComparatorIndex;
                        const optionContainerClass = classnames('option-container', {
                            selected: isSelected && isOptionSelected,
                        });
                        return React.createElement("div", { className: optionContainerClass, onClick: e => {
                                setSelectedComparatorIndex(index);
                                if (!isSelected)
                                    setSelectedElement(['clause', clauseKey]);
                                e.stopPropagation();
                            } },
                            "Page ",
                            clause.pageNumber);
                    }))))));
    };
    const hasNavigation = (anchorClauses.length && anchorClauses.some(c => c.coordinates && c.pageNumber)) || (compClauses.length && compClauses.some(c => c.coordinates && c.pageNumber));
    const deClass = classnames('data-element clause', {
        'has-navigation': hasNavigation,
        'selected': isSelected,
    });
    const dataElementSelection = () => {
        if (!hasNavigation)
            return;
        if (isExpanded) {
            setIsExpanded(false);
            if (isSelected)
                setSelectedElement(['clause', `clear-${clauseKey}`]);
        }
        else {
            setSelectedElement(['clause', clauseKey]);
            setIsExpanded(true);
        }
    };
    return React.createElement("div", { className: deClass, onClick: dataElementSelection },
        React.createElement("div", { className: 'category-row' },
            React.createElement("div", { className: 'category-title' }, "Clause"),
            hasNavigation &&
                React.createElement("div", { className: 'toggle-icons', key: `${clauseKey}-${isExpanded}` },
                    React.createElement("i", { className: !isExpanded ? 'fal fa-angle-up' : 'fal fa-angle-down' }))),
        buildBody());
};
export default ClauseElement;
